import React, { useState } from "react";
import { RESUME_TIPS, SECTION_SAMPLES } from "../../utils/constants";
import Button from "../Button/Button";
import { ChevronLeft, ChevronRight, InfoIcon } from "../Icons/Icons";
import Popup from "../Popup/Popup";
import styles from "./SectionSamples.module.css";

function SectionSamples({ section, className }) {
  const [showPopup, togglePopup] = useState(false);
  const [index, setIndex] = useState(0);

  const sample = SECTION_SAMPLES[section][index];
  return (
    <div className={`${styles.resumeTip} ${className}`}>
      <Button
        type="link"
        content="View Samples"
        onClick={() => togglePopup((show) => !show)}
      />

      {showPopup && (
        <Popup className={styles.popup} contentClassName={styles.popupContent} onClose={() => togglePopup(false)}>
          <button
            className={styles.button}
            disabled={index == 0}
            onClick={() => setIndex((ix) => ix - 1)}
          >
            <ChevronLeft />
          </button>
          <button
            className={styles.button}
            disabled={index == SECTION_SAMPLES[section]?.length - 1}
            onClick={() => setIndex((ix) => ix + 1)}
          >
            <ChevronRight />
          </button>
          <span className={styles.count}>
            {index + 1} of {SECTION_SAMPLES[section].length}
          </span>

          {["SUM", 'HOB'].includes(section) ? (
            <p>{sample}</p>
          ) : (
            <div className={styles.content}>
              <b>{sample.degree}</b>
              <p style={{ margin: "2px 0" }}>
                {sample.institute}, {sample.location}
              </p>
              <em>
                {sample.startDate} - {sample.endDate}
              </em>
              <p dangerouslySetInnerHTML={{ __html: sample?.description }} />
            </div>
          )}
        </Popup>
      )}
    </div>
  );
}

export default SectionSamples;
